import { HeadTitleContent } from '../../../commons/Constants';
import FaqPage from '../../../components/body/faq/Faq';

export default function Faq() {
  return <FaqPage />;
}

export async function getStaticProps(context) {
  return {
    props: {
      extraMeta: {
        title: HeadTitleContent['faq'].title,
        description: HeadTitleContent['faq'].description,
        schemaData: 'faq',
      },
    },
  };
}
